import React from "react";
import ReactDOM from "react-dom";
import AppWrapper from "./components/App/AppWrapper";
import * as serviceWorker from "./serviceWorker";
import { defineCustomElements } from "@ionic/pwa-elements/loader";

defineCustomElements(window);

function Root() {
    return (
        <AppWrapper />
    );
}


ReactDOM.render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
